import { IS_LOADING, STATE_LIST_SUCCESS, STATE_LIST_ERROR, STATE_UPDATE_SUCCESS, STATE_UPDATE_ERROR } from "../actions/Type";

const initialState = {
    state_list: {},
    state_updated: {},
    loading: false,
};

export const StateReducers = (
    state = initialState,
    { type, payload } = {},
) => {
    switch (type) {
        case IS_LOADING:
            return {
                ...state,
                loading: true,
            };
        case STATE_LIST_SUCCESS:
            return {
                ...state,
                state_list: payload,
                loading: false,
            };
        case STATE_LIST_ERROR:
            return {
                ...state,
                state_list: payload,
                loading: false,
            };

        case STATE_UPDATE_SUCCESS:
            return {
                ...state,
                state_updated: payload,
                loading: false,
            };
        case STATE_UPDATE_ERROR:
            return {
                ...state,
                state_updated: payload,
                loading: false,
            };

        default:
            return state;
    }
};
